// 差旅费
import ticket from "@/asserts/img/ico_cost_1.png"
// 团建费
import team from "@/asserts/img/ico_cost_2.png"
// 餐饮费
import catering from "@/asserts/img/ico_cost_3.png"
// 会议/活动
import metting from "@/asserts/img/ico_cost_4.png"
// 车辆费
import vehicle from "@/asserts/img/ico_cost_5.png"
// 调研费
import visit from "@/asserts/img/ico_cost_6.png"
// 房租费
import rent from "@/asserts/img/ico_cost_7.png"
// 其他支出
import other from "@/asserts/img/ico_cost_8.png"
// 水电费
import water from "@/asserts/img/ico_cost_9.png"
// 检测费
import detection from "@/asserts/img/ico_cost_10.png"
// 培训费
import train from "@/asserts/img/img_feiyong_15.png"
// 采购需求
import purchase from "@/asserts/img/img_feiyong_16.png"

import {costApi}  from "@/services";
import {researchApi}  from "@/services";


let jobDesc = (detailStatus) => {
	if( detailStatus == "1" ) {
		return "高阶岗P4(含)以上";
	}
	if( detailStatus == "2" ) {
		return "普通岗P3(含)以下";
	}
	if( detailStatus == "3" ) {
		return "实习生";
	}
	if( detailStatus == "4" ) {
		return "劳务工";
	}
}
let typeDesc = (type) => {
	// travel：差旅,teamBuild：团建,train：培训,catering：餐饮费,car：车辆,visit：调研,purchase：采购,other：其他, activityMeeting: 会议/活动, public: 公共服务
	if( type == "travel" ) {
		return "差旅费";
	}
	if( type == "teamBuild" ) {
		return "团建费";
	}
	if ( type == "train" ) {
		return "培训费";
	}
	if( type == "catering" ) {
		return "餐饮费";
	}
	if( type == "car" ) {
		return "车辆费";
	}
	if( type == "visit" ) {
		return "调研费";
	}
	if( type == "purchase" ) {
		return "日常采购";
	}
	if( type == "other" ) {
		return "其他零星支出";
	}
	if( type == "activityMeeting" ) {
		return "会议/活动";
	}
	if( type == "public" ) {
		return "公共服务";
	}
	return "";
}
let typeAlert = (type) => {
	// travel：差旅,teamBuild：团建,train：培训,catering：餐饮费,car：车辆,visit：调研,purchase：采购,other：其他, activityMeeting: 会议/活动
	if( type == "travel" ) { // 差旅费
		return "* 日常办公出差而实际发生的车、 船、飞机、市内交通费、住宿费、误餐补贴等费用，不含为团建、调研、培训、会议/活动、项目发生的差旅费。";
	}
	if( type == "teamBuild" ) { // 团建费
		return "* 团建包含场租、资料、劳务、展示等。";
	}
	if( type == "train" ) { // 培训
		return "* 内部员工的团队建设费用，包含团建中涉及的餐饮、交通、采购等费用。";
	}
	if( type == "catering" ) { // 餐饮费
		return "* 内部交际指公司内部员工的餐饮费，加班餐费指为加班发生的餐饮费。";
	}
	if( type == "car" ) { // 车辆费
		return "* 1.司机的里程补贴金额不在车辆中填报，已包含在工资中；2.营销支持部和集团办公室请在车辆中填写ETC费用，并在详细说明中备注（若未备注，归口ETC费用将无法分摊，全部计入车辆由填报部门承担）；3.金融财务中心-本部请在车辆填写加油，并在详细说明中备注（若未备注，归口加油费用将无法分摊，全部计入车辆由填报部门承担）。";
	}
	if( type == "visit" ) { // 调研
		return "* 与生产经营活动相关，为了业务联系、维护社会关系等目的发生的招待行为。";
	}
	if( type == "purchase" ) { // 采购需求
		return "* 1.主计划为其他费用场景的采购需求和部门设备采购需求不在此端口填写；2.营销的房租费在从该端口填写；3.列示部门在该端口填写如下费用：a.集团&顺欣&润众设备部填写水电气费用和设备计量校验费，b.EHS管理部填写安全类设备的校验费，c.金融发展部填报保险费（车辆保险、货运险、产品责任保险、财产一切险、机器损坏险、环境污染责任保险、公众责任险、雇主责任险、人身意外伤害保险、疾病保险、临床试验保险等），d.工程部填写维修费（品类：建筑维保/设备维保/零星工程维修）；4.车间为研发服务的物料消耗不填报在车间的部门费用中；5.租房产生的水电请在其他零星支出新增费用明细项-租房水电。"
		// return str.split("。").join("<br/> &nbsp;&nbsp;&nbsp;");
	}
	if( type == "other" ) { // 其他
		return "* 如果您需要自定义其他零星支出的费用名字，请点击新增明细项；租房产生的水电请在本版块新增费用明细项-租房水电进行填写。";
	}
	if( type == "activityMeeting" ) { // 会议/活动费
		return "* 为学术会议活动发生的专家劳务费、场地费、资料费、设计制作费、交通费、住宿费等。";
	}
	if( type == "public" ) { // 会议/活动费
		return "* 公共服务预算包含内容为：政府规费、事业单位收费、社团收费。";
	}
	return "";
}
let costIcon = (chargeType) => {
	// travel：差旅,teamBuild：团建,train：培训,catering：餐饮费,car：车辆,visit：调研,purchase：采购,other：其他, activityMeeting: 会议/活动
	if( chargeType == "travel" ) {
		return ticket;
	}
	if( chargeType == "teamBuild" ) {
		return team;
	}
	if( chargeType == "train" ) {
		return train;
	}
	if( chargeType == "catering" ) {
		return catering;
	}
	if( chargeType == "car" ) {
		return vehicle;
	}
	if( chargeType == "visit" ) {
		return visit;
	}
	if( chargeType == "purchase" ) {
		return purchase;
	}
	if( chargeType == "other" ) {
		return other;
	}
	if( chargeType == "activityMeeting" ) {
		return metting;
	}
	return "";
}
let DepartDesc = (detailStatus) => {
	if( detailStatus == "1" ) {
		return "行政管理部门";
	}
	if( detailStatus == "2" ) {
		return "生产部门";
	}
	if( detailStatus == "3" ) {
		return "研发部门";
	}
}
let waterDesc = (status) => {
	if( status == "9" ) {
		return "水费";
	}
	if( status == "10" ) {
		return "电费";
	}
	if( status == "11" ) {
		return "气费";
	}
}

// 1：大型会议，2：中型会议，3：小型会议，4：其他
let actDesc = (status) => {
	if( status == "1" ) {
		return "大型会(单场大于50万)";
	}
	if( status == "2" ) {
		return "中型会(单场10-50万)";
	}
	if( status == "3" ) {
		return "小型会(单场小于10万)";
	}
	if( status == "4" ) {
		return "参会形式";
	}
}
const status = {
	state: {
		jobDesc: jobDesc,
		typeDesc: typeDesc,
		typeAlert: typeAlert,
		costIcon: costIcon,
		DepartDesc: DepartDesc,
		waterDesc: waterDesc,
		actDesc: actDesc,
		categoryList: null,
		categoryList_no: null, //物料分类过滤掉 基建工程项和设备项
		initList:null
	},
	mutations: {
		setCategoryList: (state, Data) => {
				state.categoryList = Data;
		},
		setCategoryList_no: (state, Data) => {
			state.categoryList_no = Data;
		},
		setInitList:(state,Data)=>{
			state.initList=Data
		}
	},
	actions: {
		async getCategoryList({ commit }, param) {
			let _this = this;
			return costApi.fetchCategoryList( { categoryStatus: "0", categoryType: "material" } ).then(res => {
				if (res && res.msgCode == '100' ) {
					if (res.responseData) {
						//物料分类过滤掉 基建工程项和设备项
						let listNo=JSON.parse(JSON.stringify(res.responseData.filter(item=>{
							return item.id!="programmeProject" && item.id!="deviceClasses"
						})))
						listNo.forEach((item, index) => {
							item.categoryList.forEach((subitem, subindex) => {// erji
								subitem._baseIndex = index;
								if(subitem.categoryList&&subitem.categoryList.length){
									subitem.categoryList.forEach((thirditem, thirdindex) => {// sanji
										thirditem._baseIndex = index;
										thirditem._firstIndex = subindex;
										if( thirditem.categoryList && thirditem.categoryList.length ){
											thirditem.categoryList.forEach((forthitem) => {//siji
												forthitem._baseIndex = index;
												forthitem._firstIndex = subindex;
												forthitem._thirdIndex = thirdindex;
											})
										}
									});
								}
							});
						});

						res.responseData.forEach((item, index) => {
							item.categoryList.forEach((subitem, subindex) => {
								subitem._baseIndex = index;
								if(subitem.categoryList&&subitem.categoryList.length){
									subitem.categoryList.forEach((thirditem,thirdindex) => {
										thirditem._baseIndex = index;
										thirditem._firstIndex = subindex;

										
										if( thirditem.categoryList && thirditem.categoryList.length ){
											thirditem.categoryList.forEach((forthitem) => {//siji
												forthitem._baseIndex = index;
												forthitem._firstIndex = subindex;
												forthitem._thirdIndex = thirdindex;
											})
										}
									});
								}
							});
						});

						commit('setCategoryList', res.responseData);
						commit('setCategoryList_no', listNo);
						return res;
					}
				}
			});
		},
		getInitList({commit},param){
			return researchApi.categorys({categorys:"bizdic"}).then((res)=>{
				this.assetsList=res.responseData[0].itemList
				if(res && res.msgCode == '100'){
					commit('setInitList', res.responseData[0].itemList);
					return res.responseData[0].itemList;
				}
			})
		}

	}
}
export default status
